import React from 'react';
import PropTypes from 'prop-types';
import { Box, Card, CardContent, Typography } from '@mui/material';
import AssignmentIcon from '@mui/icons-material/Assignment';
import GroupIcon from '@mui/icons-material/Group';
import WarningIcon from '@mui/icons-material/Warning';
import TrendingUp from '@mui/icons-material/TrendingUp';
import { LoadingWrapper } from '../loading';
import useResponsive from '../../hooks/useResponsive';

const AssignmentStatsCards = ({ stats, isLoading }) => {
  const mdUp = useResponsive('up', 'md');

  return (
    <LoadingWrapper
      isLoading={isLoading}
      loadingType="skeleton"
      skeletonCount={4}
      gridProps={{ xs: 12, sm: 6, md: 3 }}
      containerSx={{ marginY: 3 }}
    >
      <Box display={mdUp ? 'flex' : ''} gap={2} marginY={3}>
        <Card sx={{ minWidth: 200, flex: 1, marginBottom: mdUp ? 0 : 2 }}>
          <CardContent>
            <Box display="flex" alignItems="center">
              <Box
                sx={{
                  backgroundColor: 'primary.main',
                  borderRadius: 2,
                  p: 1,
                  mr: 2,
                }}
              >
                <AssignmentIcon sx={{ color: 'white' }} />
              </Box>
              <Box>
                <Typography variant="h6">{stats.total_assignments || 0}</Typography>
                <Typography variant="body2" color="textSecondary">
                  Total Assignments
                </Typography>
              </Box>
            </Box>
          </CardContent>
        </Card>

        <Card sx={{ minWidth: 200, flex: 1, marginBottom: mdUp ? 0 : 2 }}>
          <CardContent>
            <Box display="flex" alignItems="center">
              <Box
                sx={{
                  backgroundColor: 'success.main',
                  borderRadius: 2,
                  p: 1,
                  mr: 2,
                }}
              >
                <GroupIcon sx={{ color: 'white' }} />
              </Box>
              <Box>
                <Typography variant="h6">{stats.active_assignments || 0}</Typography>
                <Typography variant="body2" color="textSecondary">
                  Active Assignments
                </Typography>
              </Box>
            </Box>
          </CardContent>
        </Card>

        <Card sx={{ minWidth: 200, flex: 1, marginBottom: mdUp ? 0 : 2 }}>
          <CardContent>
            <Box display="flex" alignItems="center">
              <Box
                sx={{
                  backgroundColor: 'warning.main',
                  borderRadius: 2,
                  p: 1,
                  mr: 2,
                }}
              >
                <WarningIcon sx={{ color: 'white' }} />
              </Box>
              <Box>
                <Typography variant="h6">{stats.unassigned_clients || 0}</Typography>
                <Typography variant="body2" color="textSecondary">
                  Unassigned Clients
                </Typography>
              </Box>
            </Box>
          </CardContent>
        </Card>

        <Card sx={{ minWidth: 200, flex: 1 }}>
          <CardContent>
            <Box display="flex" alignItems="center">
              <Box
                sx={{
                  backgroundColor: 'info.main',
                  borderRadius: 2,
                  p: 1,
                  mr: 2,
                }}
              >
                <TrendingUp sx={{ color: 'white' }} />
              </Box>
              <Box>
                <Typography variant="h6">{stats.total_clients || 0}</Typography>
                <Typography variant="body2" color="textSecondary">
                  Total Clients
                </Typography>
              </Box>
            </Box>
          </CardContent>
        </Card>
      </Box>
    </LoadingWrapper>
  );
};

AssignmentStatsCards.propTypes = {
  stats: PropTypes.shape({
    total_assignments: PropTypes.number,
    active_assignments: PropTypes.number,
    unassigned_clients: PropTypes.number,
    total_clients: PropTypes.number,
  }).isRequired,
  isLoading: PropTypes.bool.isRequired,
};

export default AssignmentStatsCards;
